import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Reward-incrementality cohorts — reads the read-only Admin_RTo3_Cohorts proc via
// the Store WebAPI. Same token-refresh pattern as RTo3Service.
export default class CohortService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getCohorts(fromDate, toDate, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_RTO3_COHORTS });
    let out = [];
    const payload = { fromDate: fromDate || null, toDate: toDate || null };
    await api.endpoints[this.endpoint.GET_RTO3_COHORTS]
      .getAllPost(payload)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getCohorts(fromDate, toDate, true);
      } catch (e) {
        out = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return out && Array.isArray(out.data) ? out.data : out;
  }
}
